// SEO constants for the application
export const SEO_CONSTANTS = {
  // General SEO constants
  SITE_NAME: "Pathshala Sanchalak",
  SITE_URL: "https://pathshalasanchalak.in",
  SITE_LOGO: "/logo512.png",

  // Default title and descriptions
  DEFAULT_TITLE:
    "Pathshala Sanchalak - Complete School and Coaching Management System",
  DEFAULT_DESCRIPTION:
    "India's leading school & coaching management system. Streamline student administration, faculty management, and academic operations with our comprehensive education ERP.",

  // Core keywords for the application
  CORE_KEYWORDS: [
    "school management system",
    "coaching management system",
    "education management system",
    "faculty management software",
    "student management system",
    "school ERP software",
    "coaching institute software",
    "tuition management system",
    "education software India",
    "attendance management system",
    "fee management software",
    "online class management",
    "educational institution management",
    "course management system",
    "teaching platform India",
    "education portal software",
    "coaching institute management",
    "school administration software",
    "academic management",
    "learning management system",
  ],

  // Page-specific keywords
  HOMEPAGE_KEYWORDS: [
    "best school management software",
    "coaching center management",
    "education management platform",
    "tuition center software",
    "institution management system",
  ],

  BLOG_KEYWORDS: [
    "education blog",
    "school management tips",
    "coaching center management",
    "educational best practices",
    "teaching tips",
  ],

  DASHBOARD_KEYWORDS: [
    "school dashboard",
    "coaching analytics",
    "education management dashboard",
    "student performance metrics",
    "faculty performance tracking",
  ],

  // Social media links
  SOCIAL_LINKS: {
    FACEBOOK: "https://facebook.com/pathshalasanchalak",
    TWITTER: "https://twitter.com/pathshalasanchalak",
    LINKEDIN: "https://linkedin.com/company/pathshala-sanchalak",
    INSTAGRAM: "https://instagram.com/pathshalasanchalak",
  },

  // Helper function to get combined keywords
  getCombinedKeywords: (pageSpecificKeywords = []) => {
    // Take 10 core keywords and add page-specific ones
    const coreSubset = SEO_CONSTANTS.CORE_KEYWORDS.slice(0, 10);
    return [...coreSubset, ...pageSpecificKeywords].join(", ");
  },
};
